import { useEffect } from 'react';
import { useHistoryStore } from '@/lib/store/history-store';
import { CreditCard, CheckCircle2, Loader2 } from 'lucide-react';

interface SubscriptionStatusCardProps {
  showUpgrade?: boolean;
}

export function SubscriptionStatusCard({ showUpgrade = true }: SubscriptionStatusCardProps) {
  const { isSubscribed, subscriptionPlan, isLoadingSubscription, isSubscriptionLoaded, loadSubscriptionFromFirestore } = useHistoryStore();

  // Load subscription from Firestore on mount if not already loaded this session
  useEffect(() => {
    if (!isSubscriptionLoaded) {
      loadSubscriptionFromFirestore();
    }
  }, [isSubscriptionLoaded, loadSubscriptionFromFirestore]);

  const planLabel = subscriptionPlan === 'max' ? 'MAX' : 'PRO';

  return (
    <div className="p-4 bg-white border border-gray-200 rounded-lg shadow-sm">
      <div className="flex items-center gap-3">
        <div className={`p-2 rounded-full ${isSubscribed ? 'bg-green-100' : 'bg-gray-100'}`}>
          {isLoadingSubscription ? (
            <Loader2 className="w-5 h-5 text-gray-500 animate-spin" />
          ) : isSubscribed ? (
            <CheckCircle2 className="w-5 h-5 text-green-600" />
          ) : (
            <CreditCard className="w-5 h-5 text-gray-500" />
          )}
        </div>
        <div>
          <div className="font-semibold text-gray-900 flex items-center gap-2">
            Subscription Status
            {isLoadingSubscription && <span className="text-xs font-normal text-gray-400">(Loading...)</span>}
          </div>
          <div className="text-sm text-gray-500">
            {isSubscribed ? `Active - ${planLabel} Plan` : 'Free Plan'}
          </div>
        </div>
      </div>
      {!isSubscribed && !isLoadingSubscription && showUpgrade && (
        <button
          onClick={() => window.location.href = '/paywall'}
          className="w-full mt-2 py-2 bg-black text-white text-sm font-medium rounded-lg hover:bg-gray-800 transition-colors"
        >
          Upgrade to Pro
        </button>
      )}
    </div>
  );
}

